(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealAll(els) {
    for (var i = 0; i < els.length; i++) els[i].classList.add('is-revealed');
  }

  function initReveal() {
    var els = document.querySelectorAll('.reveal');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      revealAll(els);
      return;
    }

    for (var i = 0; i < els.length; i++) {
      var idx = 0;
      var p = els[i].previousElementSibling;
      while (p) {
        if (p.classList && p.classList.contains('reveal')) idx++;
        p = p.previousElementSibling;
      }
      els[i].style.transitionDelay = Math.min(idx * 70, 350) + 'ms';
    }

    var io = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            entries[i].target.classList.add('is-revealed');
            io.unobserve(entries[i].target);
          }
        }
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );
    for (var j = 0; j < els.length; j++) io.observe(els[j]);

    setTimeout(function () {
      revealAll(els);
    }, 4000);
  }

  function animateValue(el) {
    var raw = (el.textContent || '').trim();
    var m = raw.match(/^([^\d.-]*)([\d.,]+)(.*)$/);
    if (!m) return;
    var prefix = m[1];
    var numStr = m[2];
    var suffix = m[3];
    var hasComma = numStr.indexOf(',') >= 0;
    var decimals = numStr.indexOf('.') >= 0 ? numStr.split('.')[1].length : 0;
    var target = parseFloat(numStr.replace(/,/g, ''));
    if (isNaN(target)) return;

    function fmt(v) {
      var s;
      if (decimals) s = v.toFixed(decimals);
      else if (hasComma) s = Math.round(v).toLocaleString('en-US');
      else s = String(Math.round(v));
      return prefix + s + suffix;
    }

    var dur = 1100;
    var start = 0;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min(1, (ts - start) / dur);
      var e = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(target * e);
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = fmt(target);
    }
    requestAnimationFrame(step);
  }

  function initCount() {
    var panels = document.querySelectorAll('.signal-solutions__panel');
    if (!panels.length || reduce || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            var vals = entries[i].target.querySelectorAll('.dash__kpi-value');
            for (var k = 0; k < vals.length; k++) animateValue(vals[k]);
            io.unobserve(entries[i].target);
          }
        }
      },
      { threshold: 0.4 }
    );
    for (var j = 0; j < panels.length; j++) io.observe(panels[j]);
  }

  function init() {
    initReveal();
    initCount();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
